export function removeWhiteSpaces(str: string) {
  return str.replace(/ /g, '')
}

export function concatUrl(url: string, urlToConcat: string) {
  if (!url.includes('?')) {
    return url + '/?' + urlToConcat
  } else {
    return url + '&' + urlToConcat
  }
}

export function replaceAllStrings(
  str: string,
  subStrToReplace: string,
  subStrReplacement: string
) {
  const re = new RegExp(subStrToReplace, 'g')
  return str.replace(re, subStrReplacement)
}
type Options = {
  allUppercase?: boolean
  replaceAll?: boolean
}
export function capitalizeSubStrings(
  str: string,
  subStrings: string[],
  { allUppercase = false, replaceAll = false }: Options = {}
) {
  for (const subString of subStrings) {
    const uppercaseSubstr = allUppercase
      ? subString.toUpperCase()
      : subString.charAt(0).toUpperCase() + subString.slice(1)
    if (replaceAll) {
      str = replaceAllStrings(str, subString, uppercaseSubstr)
    } else {
      str = str.replace(subString, uppercaseSubstr)
    }
  }
  return str
}

export function capitalizeString(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function capitalizeSentences(
  str: string,
  { withSpaces = true }: { withSpaces: boolean } = { withSpaces: true }
) {
  const divider = withSpaces ? ' ' : ''
  return str
    .split(`.${divider}`)
    .map(sentence => capitalizeString(sentence.trim()))
    .join(`.${divider}`)
}

export function capitalizeAllWords(str: string) {
  return str
    .split(' ')
    .map(word => capitalizeString(word.trim()))
    .join(' ')
}

export const capitalizeWords = capitalizeAllWords // alias

export function getLines(str: string) {
  return str.split(/\r?\n/)
}

/**
 * Naive implementation.
 * @param {string} str
 * @returns {boolean}
 */
export function isEmail(str: string) {
  const indexOfAtSign = str.indexOf('@')
  return Boolean(
    str &&
      indexOfAtSign > -1 &&
      indexOfAtSign === str.lastIndexOf('@') &&
      indexOfAtSign < str.lastIndexOf('.')
  )
}

const greekToLatinMapping: Record<string, string> = {
  α: 'a',
  β: 'v',
  γ: 'g',
  δ: 'd',
  ε: 'e',
  ζ: 'z',
  η: 'i',
  θ: 'th',
  ι: 'i',
  κ: 'k',
  λ: 'l',
  μ: 'm',
  ν: 'n',
  ξ: 'x',
  ο: 'o',
  π: 'p',
  ρ: 'r',
  σ: 's',
  ς: 's',
  τ: 't',
  υ: 'y',
  φ: 'f',
  χ: 'x',
  ψ: 'ps',
  ω: 'o'
}

export function transliterateGreekToLatin(s: string) {
  return s
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036F]/g, '')
    .split('')
    .map(char => greekToLatinMapping[char] || char)
    .join('')
}

export function textExistsInString(text: string, str: string) {
  return transliterateGreekToLatin(str).includes(
    transliterateGreekToLatin(text)
  )
}

/**
 * Encodes string to base64.
 * @param {string | *} str
 * @returns {string} Base64 encoded string
 */
export function toBase64(str: string) {
  return Buffer.from(String(str)).toString('base64')
}

export function trimEnd(str: string, char: string = ' '): string {
  if (char.length !== 1) {
    throw new TypeError(`Character should have length 1: ${char}`)
  }

  let trimmed: string = str
  for (let i = str.length - 1; i > 0; i--) {
    if (trimmed[i] !== char) {
      return trimmed
    }

    trimmed = trimmed.substring(0, trimmed.length - 1)
  }
  return ''
}
